import { HiSparkles } from "react-icons/hi2";

const TitleStripe = ({ children, className = "" }) => {
  return (
    <div className={`flex items-center gap-3 my-6 ${className}`}>
      {/* Texto */}
      <h2 className="text-2xl md:text-2xl font-semibold tracking-tight text-gray-900 dark:text-gray-100">
        {children}
      </h2>

      {/* Linha expandida */}
      <div className="flex-1 h-[1px] bg-gradient-to-r from-green-400 to-green-400 ml-3"></div>
    </div>
  );
};

export default TitleStripe;
